import type { IAttentionOfferingMask } from '../model/types'

interface IGetAttentionMasksForOfferingParams {
  masks: IAttentionOfferingMask[]
  /** Offering in view; `undefined` stands for the partner as a whole — every offering's mask. */
  offering?: string
}

/**
 * The masks that count for the offering in view, each still naming the offering it came from —
 * that name is what titles the row. An offering the partner carries no entry for raises nothing,
 * so the tile stays empty instead of borrowing another offering's statuses.
 */
export const getAttentionMasksForOffering = ({
  masks,
  offering,
}: IGetAttentionMasksForOfferingParams): IAttentionOfferingMask[] =>
  offering === undefined ? masks : masks.filter((entry) => entry.offering === offering)
